<template>
    <div>
        <!--expand-trigger="hover" -->
        <el-cascader :key="modalKey" v-model="location" :size="size" ref="arearef" placeholder="请选择区域" :props="propsprops" @change="getNode" clearable style="width: 100%;"></el-cascader>
    </div>
</template>

<script>
// let id = 0
import { getProvince, getCity, getArea, getCommunity } from '@/api/region'
export default {
    name: '',
    props: {
        checkStrictly: {
            type: Boolean,
            default: true
        },
        size:{
            default:'normal'
        },
        communityCode: {
            default:''
        }
    },
    data() {
        let that=this
        return {
            modalKey:0,
            // optionsChanged: false,
            provinceCode: '',
            cityCode: '',
            areaCode: '',
            xiaoquCode: '',
            location:[],
            resolve_:null,
            // jibie: this.level1,
            propsprops: {
                // expandTrigger: 'hover',
                /*isLeaf: (data,node)=>{
                    if(node.level === 3){
                        return true
                    }
                },*/
                lazy: true,
                lazyLoad (node, resolve) {
                    that.resolve_ = resolve
                    const { level } = node
                    // console.log('level',level,node)
                    if (level === 0||level === '0') {
                        that.getProvinces((list1)=>{
                            let arr = list1.map((e) => ({ value: e.provinceCode, label: e.provinceName }))
                            // console.log(arr)
                            resolve(arr)
                        })
                    }else if (level === 1||level === '1') {
                        let { value } = node
                        // console.log(node)
                        that.provinceCode = value
                        that.getCitys((list2)=>{
                            let arr = list2.map((e) => ({ value: e.cityCode, label: e.cityName }))
                            // console.log(arr)
                            resolve(arr)
                        })
                    }else if (level === 2||level === '2') {
                        let { value } = node
                        // console.log(value)
                        that.cityCode = value
                        that.getAreas((list3)=>{
                            let arr = []
                            arr = list3.map((e) => ({ value: e.areaCode, label: e.areaName }))
                            resolve(arr)
                        })
                    }else if (level === 3||level === '3') {
                        let { value } = node
                        // console.log(value)
                        that.areaCode = value
                        that.getCommunitys((list4)=>{
                            let arr = list4.map((e) => ({ value: e.communityCode, label: e.communityName, leaf:level >= 3 }))

                            resolve(arr)
                            //console.log(arr)
                        })
                    }
                },
                checkStrictly: this.checkStrictly
            }
        }
    },
    methods: {
        getNode(val) {
            console.log("methods节点。。。" + val)
            if(val!=''){
                var label = ''
                if(this.$refs.arearef.getCheckedNodes()[0]){
                    label=this.$refs.arearef.getCheckedNodes()[0].pathLabels
                }
                this.$emit('nodeChange', val,label)
            }else{
                this.$emit('nodeChange', [],[])
            }
        },
        getProvinces(callback){
            getProvince().then(response => {
                if(response.code===200){
                   callback(response.data)
                }else{
                    callback([])
                }
            })
        },
        getCitys(callback){
            console.log('选中省',this.provinceCode)
            getCity(this.provinceCode).then(response => {
                if(response.code===200){
                    callback(response.data)
                }else{
                    callback([])
                }
            })
        },
        getAreas(callback){
            console.log('选中市',this.cityCode)
            getArea(this.cityCode).then(response => {
                if(response.code===200){
                    callback(response.data)
                }else{
                    callback([])
                }
            })
        },
        getCommunitys(callback){
            console.log('选中区',this.areaCode)
            getCommunity({areaCode: this.areaCode, cityCode: this.cityCode, provinceCode: this.provinceCode} ).then(response=>{
                if(response.code===200){
                    callback(response.data)
                }else{
                    callback([])
                }
            })
        },
        init(){
            this.$nextTick(() => {
                //let that = this
                this.$set(this,'location',[])
                if(this.communityCode!=''){
                    console.log('获取到小区号',this.communityCode)
                    this.provinceCode=this.communityCode.substring(0,2)
                    this.cityCode=this.communityCode.substring(0,4)
                    this.areaCode=this.communityCode.substring(0,6)
                    this.xiaoquCode=this.communityCode
                    //console.log('选中',this.location)
                    this.$set(this, 'location', [Number(this.provinceCode), Number(this.cityCode), Number(this.areaCode), Number(this.xiaoquCode)])
                    this.modalKey++;
                    /*setTimeout(() => {
                        this.propsprops.lazyLoad({level: 1, value: Number(this.provinceCode)}, this.resolve_)
                        console.log(this.resolve_)
                    }, 500)
                    setTimeout(() => {
                        this.propsprops.lazyLoad({level: 2, value: Number(this.cityCode)}, this.resolve_)
                        console.log(this.resolve_)
                    }, 1000)
                    setTimeout(() => {
                        this.propsprops.lazyLoad({level: 3, value: Number(this.areaCode)}, this.resolve_)
                        console.log(this.resolve_)
                    }, 1500)
                    setTimeout(() => {
                        this.$set(this, 'location', [Number(this.provinceCode), Number(this.cityCode), Number(this.areaCode), Number(this.xiaoquCode)])
                    }, 2000)*/
                }else{
                    console.log('init',this.communityCode)
                }
            })
        }
    },
    watch:{
        'communityCode':{
            handler: function() {
                // console.log(this.communityCode)
                this.init()
            }
        }
    },
    created(){
        //this.init()
    }
}
</script>

<style scoped>

</style>
